import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { KycReprocessingForm } from "../formsForInstitutionConfig/kycReprocessing";
import { TransactionReprocessingForm } from "../formsForInstitutionConfig/transactionReprocess";
import { makeRequest } from "../common/customServiceCall/serviceCall";
import { format } from "date-fns";

export const InstitutionConfigurations = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const formatDate = (dateString) => {
    return format(new Date(dateString), "yyyy-MM-dd HH:mm:ss");
  };
  // Function to handle tab switch
  const handleTabsSwitch = (tab) => {
    setActiveIndex(tab);
  };

  const [formData, setFormData] = useState({});
  const [mockDataForKYC, setMockDataForKYC] = useState({
    id: "",
    institutionId: "",
    maxAttempts: "",
    onLimitReached: "",
    createdAt: "",
    modifiedAt: "",
  });
  const [mockDataForTransaction, setMockDataForTransaction] = useState({
    id: "",
    institutionId: "",
    maxAttempts: "",
    onLimitReached: "",
    createdAt: "",
    modifiedAt: "",
  });

  useEffect(() => {
    const id = sessionStorage.getItem("selectedInstitutionId");
    fetchData(id);
    fetchDataTrans(id);
  }, []);

  const fetchData = async (id) => {
    try {
      const response = await makeRequest(
        "mainApi",
        "get",
        `kres/api/v1/kycreprocess/evaluation/${id}`
      );

      if (response.code === "00") {
        // Check if data exists and is an array
        const fetchedData = response.data;
        if (Array.isArray(fetchedData) && fetchedData.length > 0) {
          const data = fetchedData[0]; // Get the first item from the array

          // Set the state with the data
          setMockDataForKYC({
            id: data.id || "N/A",
            institutionId: data.institutionId || "N/A",
            maxAttempts: data.maximumNumberOfAttempt || "N/A", // Use the correct field from response
            onLimitReached: data.onLimitReached || "N/A",
            createdAt: data.createdAt ? formatDate(data.createdAt) : "N/A",
            modifiedAt: data.modifiedAt ? formatDate(data.modifiedAt) : "N/A",
          });
        } else {
          setMockDataForKYC({});
        }
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  const fetchDataTrans = async (id) => {
    // setLoading(true); // Uncomment if you are managing loading state
    try {
      const response = await makeRequest(
        "get",
        `tres/api/v1/txnreprocess/evaluation/${id}`
      );

      if (response.code === "00") {
        // Check if data exists and is an array
        const fetchedData = response.data;
        if (Array.isArray(fetchedData) && fetchedData.length > 0) {
          const data = fetchedData[0]; // Get the first item from the array

          // Set the state with the data
          setMockDataForTransaction({
            id: data.id || "N/A",
            institutionId: data.institutionId || "N/A",
            maxAttempts: data.maximumNumberOfAttempt || "N/A", // Use the correct field from response
            onLimitReached: data.onLimitReached || "N/A",
            createdAt: data.createdAt ? formatDate(data.createdAt) : "N/A",
            modifiedAt: data.modifiedAt ? formatDate(data.modifiedAt) : "N/A",
          });
        } else {
          setMockDataForTransaction({});
        }
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  return (
    <div className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <div className="p-grid">
        <div
          className="p-col-12 p-md-4 p-xl-4 p-md-offset-4 p-xl-offset-4"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">
            Institution Configurations
          </span>
        </div>
      </div>
      <div className=" py-2 ">
        <div className="pt-1 pb-4 card">
          <Button
            onClick={() => handleTabsSwitch(0)}
            className={activeIndex === 0 ? "p-button-info" : "p-button-text"}
            style={{ color: "black !important" }}
            label="KYC Reprocessing"
          />
          <Button
            onClick={() => handleTabsSwitch(1)}
            className={activeIndex === 1 ? "p-button-info" : "p-button-text"}
            label="Transaction Reprocessing"
          />
        </div>

        {activeIndex === 0 ? (
          <div>
            <KycReprocessingForm data={mockDataForKYC} />
          </div>
        ) : (
          " "
        )}
        {activeIndex === 1 ? (
          <div>
            <TransactionReprocessingForm data={mockDataForTransaction} />
          </div>
        ) : (
          " "
        )}
      </div>
    </div>
  );
};
